import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

const FETCH_LOCATIONS = 'locations/FETCH_LOCATIONS'
const FETCH_LOCATIONS_SUCCESS = 'locations/FETCH_LOCATIONS_SUCCESS'
const FETCH_LOCATIONS_FAIL = 'locations/FETCH_LOCATIONS_FAIL'
const UPDATE_FILTER = 'locations/UPDATE_FILTER'
const UPDATE_SELECTED = 'locations/UPDATE_SELECTED'
const RESET_STATE = 'locations/RESET_STATE'

export const actions = {
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAIL,
  UPDATE_FILTER,
  UPDATE_SELECTED,
  RESET_STATE
}

export const initialState = {
  brands: [],
  filteredIds: [],
  filter: {
    text: '',
    state: '',
    brand: ''
  },
  locations: [],
  selected: [],
  loading: false,
  stateList: []
}

export function sortBrands(locs) {
  return [
    ...locs
      .map((location) => location.brand)
      .reduce(
        (allBrands, locBrands) => locBrands.reduce((brands, brand) => brands.add(brand), allBrands),
        new Set()
      )
  ].sort()
}

export function sortLocations(locs) {
  return locs
    .sort((a, b) => a.propNum.localeCompare(b.propNum))
    .map((loc) => ({
      ...loc,
      id: loc.propId.toString(),
      name: `${loc.propNum} - ${loc.propName}`
    }))
}

const lowCase = (str) => str.toLowerCase()

export function filterItems({ items, filter }) {
  const { text, state, brand } = filter
  const query = text.toLowerCase()

  const matchesBrand = (x) => brand === '' || x.brand.includes(brand)
  const matchesState = (x) => state === '' || x.state === state
  const matchesQuery = (x) =>
    lowCase(x.propNum).includes(query) || lowCase(x.propName).includes(query)

  return items
    .filter(matchesBrand)
    .filter(matchesQuery)
    .filter(matchesState)
    .map((x) => x.id)
}

export function getStateList(items) {
  return items.reduce((acc, x) => {
    return acc.includes(x.state) ? acc : [...acc, x.state]
  }, [])
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCATIONS:
      return {
        ...state,
        loading: true
      }
    case FETCH_LOCATIONS_SUCCESS:
      const {
        payload: { locations }
      } = action
      const sortedLocations = locations ? sortLocations(locations) : state.locations
      return {
        ...state,
        filteredIds: sortedLocations.map((x) => x.propId.toString()),
        locations: sortedLocations,
        brands: locations ? sortBrands(locations) : state.brands,
        loading: false,
        stateList: locations ? getStateList(locations) : state.stateList
      }
    case FETCH_LOCATIONS_FAIL:
      return {
        ...state,
        errorMsg: action.error,
        loading: false
      }

    case UPDATE_FILTER:
      const {
        payload: { filter, value }
      } = action
      const newFilter = {
        brand: filter === 'brand' ? value : state.filter.brand,
        state: filter === 'state' ? value : state.filter.state,
        text: filter === 'text' ? value : state.filter.text
      }
      return {
        ...state,
        filter: newFilter,
        filteredIds: filterItems({ items: state.locations, filter: newFilter })
      }

    case UPDATE_SELECTED:
      return {
        ...state,
        selected: action.payload.ids
      }

    case RESET_STATE:
      return {
        ...initialState,
        locations: state.locations,
        filteredIds: state.locations.map((x) => x.id)
      }
    default:
      return state
  }
}

export default reducer

export function fetchLocations(selectedPositions) {
  const data = JSON.stringify({
    positionIds: selectedPositions.map((x) => parseInt(x, 10))
  })

  return {
    type: CALL_API,
    types: [FETCH_LOCATIONS, FETCH_LOCATIONS_SUCCESS, FETCH_LOCATIONS_FAIL],
    callAPI: () => axios.post('/locations', data, { ...fetchOptions('v1') })
  }
}

export function updateFilter({ filter, value }) {
  return {
    type: UPDATE_FILTER,
    payload: { filter, value }
  }
}

export function updateSelected(ids) {
  return {
    type: UPDATE_SELECTED,
    payload: { ids }
  }
}

export function resetState() {
  return { type: RESET_STATE }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/locations.js